import _axios from "./index";
import store from "@/store/index"


function request(url, data = {}, method, config = { isLoading: !0 }) {
    // let lang = localStorage.getItem('lang') ? JSON.parse(localStorage.getItem('lang')).code : 'en'
    let lang = localStorage.getItem("locale") || "en"
    switch (lang) {
        case "zh": // 中文简体
            lang = "zh-cn";
            break;
        case "en": // 英文
            lang = "en-ww";
            break;
        case "ja": // 日语
            lang = "ja-jp";
            break;
        case "ko": // 韩语
            lang = "ko-kr";
            break;
        case "es": // 西班牙语
            lang = "es-mx";
            break;
        case "yinni": // 印尼语
            lang = "en-id";
            break;
        case "pt": // 葡萄牙语
            lang = "pt-br";
            break;
        case "trq": // 土耳其语
            lang = "tr-tr";
            break;
        case "yn": // 越南语
            lang = "iv-vn";
            break;

    }
    // const config = {}
    // if (data.isLoading) {
    //     config.isLoading = data.isLoading || true
    // }

    return _axios.request({
        url: data === 'GET' ? `${url}&lang=${lang}` : `${url}?lang=${lang}`,
        method: method || 'POST',
        config: config,
        data,
    },);
}

export default {
    /**
     * 客服获取接口
     *
     * @param {any} data
     * @returns
     */
    getServe(data) {
        return request("/api/support/index", data);
    },
    /**
     * 登录
     *
     * @param {any} data
     * @returns
     */
    getPwdLogin(data) {
        return request("/api/user/do_login", data);
    },
    /**
     * 注册接口
     *
     * @param {any} data
     * @returns
     */
    getRegister(data) {
        return request("/api/user/do_register", data);
    },
    /**
     * 用户信息接口
     *
     * @param {any} data
     * @returns
     */
    getmyindex(data) {
        return request("/api/my/index", data);
    },
    /**
     * 订单接口
     *
     * @param {any} data
     * @returns
     */
    getorder(data) {
        return request(`/api/order/index?status=${data}`, 'GET');
    },
    /**
     * 订单oid接口
     *
     * @param {any} data
     * @returns
     */
    getOrderInfo(data) {
        return request(`/api/order/order_info_list`, data, 'POST', { formData: true });
    },
    /**
     * 订单提交接口
     *
     * @param {any} data
     * @returns
     */
    getDoOrder(data) {
        return request(`/api/order/do_order`, data);
    },
    /**
     * 首页接口
     *
     * @param {any} data
     * @returns
     */
    getHomeIndex(data) {
        return request("/api/index/home", data, 'GET');
    },
    /**
     * 任务接口
     *
     * @param {any} data
     * @returns
     */
    getGoOrderindex(data) {
        return request("/api/rot_order/index", data, 'GET');
    },
    /**
     * 任务获取接口
     *
     * @param {any} data
     * @returns
     */
    getGoSubmit(data) {
        // return request("api", data);
        return request("/api/rot_order/submit_order", data);
    },
    /**
     * 充值接口
     *
     * @param {any} data
     * @returns
     */
    setRecharge(data) {
        return request("/api/ctrl/recharge_do_before", data);
    },
    /**
     * 充值记录接口
     *
     * @param {any} data
     * @returns
     */
    setRechargeAdmin(data) {
        return request("/api/ctrl/recharge_admin", data);
    },
    /**
     * 提现记录接口
     *
     * @param {any} data
     * @returns
     */
    setWithdrawalAdmin(data) {
        return request("/api/ctrl/deposit_admin", data, 'POST');
    },
    /**
     * 账户明细接口
     *
     * @param {any} data
     * @returns
     */
    setCaiwu(data) {
        return request("/api/my/caiwu", data, 'GET');
    },
    /**
     * 获取银行卡信息接口
     *
     * @param {any} data
     * @returns
     */
    getBindBank(data) {
        return request("/api/my/bind_bank", data, 'GET');
    },
    /**
     * 绑定银行卡接口
     *
     * @param {any} data
     * @returns
     */
    setBindBank(data) {
        return request("/api/my/bind_bank", data);
    },
    /**
     * 修改密码接口
     *
     * @param {any} data
     * @returns
     */
    setEditPwd(data) {
        return request("/api/ctrl/set_pwd", data, 'POST', { formData: true });
    },
    /**
     * 修改提现密码接口
     *
     * @param {any} data
     * @returns
     */
    setEditWithdrawPwd(data) {
        return request("/api/ctrl/set_pwd2", data, 'POST', { formData: true });
    },
    /**
     * 消息接口
     *
     * @param {any} data
     * @returns
     */
    getSystemMessages(data) {
        return request("/api/my/msg", data, 'GET');
    },
    /**
     * 邀请好友接口
     *
     * @param {any} data
     * @returns
     */
    inviteFriends(data) {
        return request("/api/my/invite", data, 'GET');
    },
    /**
     * 提现接口
     *
     * @param {any} data
     * @returns
     */
    setWithdraw(data) {
        return request("/api/ctrl/do_deposit", data, 'POST', { formData: true });
    },
    /**
     * 上传头像接口
     *
     * @param {any} data
     * @returns
     */
    setheadimg(data) {
        return request("/api/my/headimg", data, 'POST', { formData: true });
    },
    /**
     * 获取电影详情
     *
     * @param {any} data
     * @returns
    */
    getGoodsInfo(data) {
        return request("/api/index/get_goodsInfo", data, 'POST');
    },
    /**
     * 获取绑定ERC20,TRC20,BTC 地址信息接口
     *
     * @param {any} data
     * @returns
     */
    getBindWallet(data) {
        return request("/api/my/bind_wallet", data, 'GET');
    },
    /**
     * 绑定绑定ERC20,TRC20,BTC 地址信息接口
     *
     * @param {any} data
     * @returns
     */
    setBindWallet(data) {
        return request("/api/my/bind_wallet", data);
    },

}
